import request from '@/utils/request'
import axios from 'axios'
import vue from 'vue'
import { getToken } from '@/utils/auth'

const BaseUrl = '/biz-project-plan' // /bizPartnerBudgetTask

const request1 = function(loadtip, query) {
  if (loadtip) {
    vue.prototype.$loading({
      lock: false,
      text: '正在加载中…',
      spinner: 'el-icon-loading',
      background: 'rgba(0, 0, 0, 0.5)'
    })
  }
  return axios.request(query)
    .then(res => {
      console.log("ppppppppp")
        return Promise.resolve(res)
    })
}

const post = function(url, params) {
  const query = {
    baseURL: process.env.VUE_APP_BASE_API,
    url: url,
    method: 'post',
    withCredentials: true,
    timeout: 30000,
    data: params,
    headers: { 'Content-Type': 'application/json', 'request-ajax': true,'Authorization': `Bearer ${getToken()}`, }
  }
  return request1(false, query)
}

// 计划导入
export function importExcel(params) {
  return post("/biz-project-plan/importExcel",params);
}

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: true,
  timeout: 10000
})

// 项目计划新增或修改
export function addPlan(data) {
  return request({
    url: `${BaseUrl}/save`,
    method: 'post',
    data
  })
}

// 项目计划删除
export function deletePlanById(id) {
  return request({
    url: `${BaseUrl}/remove/${id}`,
    method: 'delete',
  })
}

// 项目计划详情
export function planDetails(id) {
  return request({
    url: `${BaseUrl}/get/${id}`,
    method: 'get',
  })
}

// 项目计划列表
export function planList(id) {
  return request({
    url: `${BaseUrl}/getList`,
    method: 'get',
  })
}
// 根据项目号查询项目阶段
export function planNodeList(data) {
  return request({
    url: `projectDelivery/listProjectMilestone`,
    method: 'get',
    params: data
  })
}
// 项目计划分录删除
export function delDetailPlan(id) {
  return request({
    url: `/biz-project-plan/removeEntry/${id}`,
    method: 'delete',
  })
}
// 导出
export function downloadExcel(url,params,label,date) {
  service({
    method: 'get',
    url: url,
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      filename: 'utf-8',
    },
    params
  }).then(res => {
    const fileName = `${label}.xls`
    const url = window.URL.createObjectURL(res.data)
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    document.body.appendChild(link)
    link.setAttribute('download', fileName)
    link.target = '_blank'
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }).catch(error => {
    console.log(error)
  })
}

export function downloadExcel2(url,params,fileName,date) {
  service({
    method: 'get',
    url: url,
    responseType: 'blob',
    headers: {
      Authorization: `Bearer ${getToken()}`,
      filename: 'utf-8',
    },
    params
  }).then(res => {
    const url = window.URL.createObjectURL(res.data)
    const link = document.createElement('a')
    link.style.display = 'none'
    link.href = url
    document.body.appendChild(link)
    link.setAttribute('download', fileName)
    link.target = '_blank'
    link.click()
    document.body.removeChild(link)
    window.URL.revokeObjectURL(url)
  }).catch(error => {
    console.log(error)
  })
}
// HR审批
export function billApprovalHr(params) {
  return request({
    url: `/billApprovalHr/getFlowNodeSelectUserDatas`,
    method: 'post',
    params
  })
}
// 项目计划详情
export function setSurer(params,id) {
  return request({
    url: `/biz-project-plan/setSurer/${id}`,
    method: 'get',
    params
  })
}

// 项目计划详情
export function getBizProjectPlanChange(id) {
  return request({
    url: `/biz-project-plan/getBizProjectPlanChange?id=${id}`,
    method: 'get',
  })
}

